import { BehaviorSubject } from "rxjs";
import { IMultiAutocompleteFormControlOptions } from "../multi-autocomplete-form-control/i-multi-autocomplete-form-control.options";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";
import { _SSDataSourceBase } from "./utils/ss-data-source-base";

export class SSMultiAutocompleteOptions extends _SSDataSourceBase implements _SSControlOptionsBase<'multiautocomplete'> {

    readonly loadFnSubject = new BehaviorSubject<IMultiAutocompleteFormControlOptions['loadFn']>(null);
    readonly initialSelectedItemsSubject = new BehaviorSubject<IMultiAutocompleteFormControlOptions['initialSelectedItems']>(null);



    constructor(
        private _initialOptions?: IMultiAutocompleteFormControlOptions
    ) {
        super();
        this._initOptions();

    }




    private _initOptions() {

        FormControlOptionsUtils.initMappedObject<'multiautocomplete'>(this, this._initialOptions);
    }

    dispose() {
        this.loadFnSubject.complete();
        this.initialSelectedItemsSubject.complete()
    }
}
